import styled from 'styled-components';
import Subtitle from '@components/Subtitle';
import ActionLabel from '@components/Subtitle/components/ActionLabel';

const SubtitleWithColor = styled(Subtitle)`
  margin-left: ${({ theme }) => theme.constants.lateralSpace};

  ${ActionLabel} {
    color: ${props => props.theme.colors.textPrimary};
    font-size: 12px;
    font-weight: normal;
    padding-right: ${({ theme }) => theme.constants.lateralSpace};
    color: ${({ selectionIsCompleted, theme }) =>
      selectionIsCompleted
        ? theme.colors.corporateGreen
        : theme.colors.corporateRed};
  }
`;

export default SubtitleWithColor;
